import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import Header from './Header';
import useResponsive from '../hooks/useResponsive';

const Layout = ({ children, currentPage, setCurrentPage, onLogout, theme, toggleTheme }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
      {/* Show Sidebar for Desktop and Tablet */}
      {(isDesktop || isTablet) && (
        <Sidebar 
          currentPage={currentPage} 
          setCurrentPage={setCurrentPage}
          onLogout={onLogout}
        />
      )}
      
      {/* Main Content */}
      <div className={(isDesktop || isTablet) ? 'lg:pl-64 md:pl-64' : ''}>
        <Header 
          theme={theme}
          toggleTheme={toggleTheme}
          currentPage={currentPage}
        />
        
        <main className="p-4 sm:p-6 pb-24 md:pb-6">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentPage}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>

      {/* Mobile Bottom Navigation - Only for mobile */}
      {isMobile && (
        <MobileNav currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}
    </div>
  );
};

export default Layout;